import { _ } from "../polyglot/polyglot.js";
import { uploadIcon } from "../elements/icons/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import jQuery from "jquery";
import regionWidget from "./regionWidget.js";

/**
 * Widget that displays an area where files can be dropped.
 * When files are dropped, the event `filesDropped` is triggered.
 *
 * @param {Renderable} [spec.contents] - Contents to be displayed inside the
 * drop box.
 */
export default class FileDropWidget extends Widget {
	constructor({ contents = "" }) {
		super(...arguments);

		this._files = null;
		this._contents = contents;
		this.filesDropped = this._events.createEvent();

		this._progressInfo = regionWidget({ content: _("Uploading files…") });
	}

	renderContentOn(html) {
		html.div(
			{ klass: "drop-area" },
			this._contents,
			this._renderDropHelperOn.bind(this),
		).on("drop", this._handleDroppedFiles.bind(this));
	}

	_didAttach() {
		this._dragStartHandler = this._dragStart.bind(this);
		this._dragStopHandler = this._dragStop.bind(this);
		this._cancelEventHandler = this._cancelEvent.bind(this);

		jQuery(document.body)
			.on("dragover", this._dragStartHandler)
			.on("dragstart", this._dragStartHandler)
			.on("dragend", this._dragStopHandler)
			.on("dragleave", this._dragStopHandler)
			.on("drop", this._cancelEventHandler);
	}

	_willDetach() {
		jQuery(document.body)
			.off("dragover", this._dragStartHandler)
			.off("dragstart", this._dragStartHandler)
			.off("dragend", this._dragStopHandler)
			.off("dragleave", this._dragStopHandler)
			.off("drop", this._cancelEventHandler);
	}

	_renderDropHelperOn(html) {
		html.div(
			{ klass: "drop-helper hidden" },
			html.h3(uploadIcon, this._progressInfo),
		);
	}

	_renderHiddenFormOn(html) {
		html.div({ klass: "hidden" }, this._form);
	}

	_dragStart(event) {
		this.asJQuery().find(".drop-area").addClass("dragover");
		this._cancelEvent(event);
	}

	_dragStop(event) {
		this.asJQuery().find(".drop-area").removeClass("dragover");
		this._cancelEvent(event);
	}

	_handleDroppedFiles(event) {
		this._cancelEvent(event);

		this._showDropHelper();

		const files = [...event.originalEvent.dataTransfer.files];
		let numberOfUploadedFiles = 0;

		this.filesDropped.trigger({
			files,
			fileUploadingCallback: () => {
				numberOfUploadedFiles++;
				this._handleFileUploaded(numberOfUploadedFiles, files.length);
			},
		});
	}

	_handleFileUploaded(count, total) {
		this._progressInfo.setContent(
			_("Uploading file {count} of {total}…", {
				count,
				total,
			}),
		);
	}

	_showDropHelper() {
		this.asJQuery().find(".drop-helper").removeClass("hidden");
	}

	_hideDropHelper() {
		this.asJQuery().find(".drop-helper").addClass("hidden");
	}

	_cancelEvent(event) {
		event.preventDefault();
		event.stopPropagation();
	}
}
